module.exports = __webpack_public_path__ + "img/bitshake-mobile.17daca71.png";